'use strict'

import * as types from './types';

export const createPlace = (name, placeId) => ({
	type: types.CREATE_PLACE,
	meta: {
		async: true,
		endPoint: `/places/create`,
		method: 'POST',
		body: {
			name,
			placeId,
		},
	},
});

export const searchPlaces = q => ({
	type: types.SEARCH_PLACES,
	meta: {
		async: true,
		endPoint: `/places/search?q=${ q }`,
		method: 'GET',
	},
});

export const getPlaces = () => ({
	type: types.GET_PLACES,
	meta: {
		async: true,
		endPoint: `/places/get`,
		method: 'GET',
	},
});

export const getOffices = () => ({
	type: types.GET_OFFICES,
	meta: {
		async: true,
		endPoint: `/places/offices`,
		method: 'GET',
	},
});
